import jQuery from 'jquery';

import deviceDetect from './deviceDetect';

export default function MobileHandler() {
    let classNamesToRemove;
    if (deviceDetect.phone()) {
        classNamesToRemove = 'RC-tablet RC-desktop';
    } else if (deviceDetect.tablet()) {
        classNamesToRemove = 'RC-phone RC-desktop';
    } else {
        classNamesToRemove = 'RC-phone RC-tablet';
    }
    const pageContent = jQuery('.js-ui-content');

    pageContent.removeClass(classNamesToRemove);
}



// WEBPACK FOOTER //
// ./lib/js/modules/mobileHandler.js